<p>form-map-stat works!</p>
